import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppService } from 'src/app/utils/services/app.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { DataProvider } from 'src/providers/data/data';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-salecompany-regist-comp',
  templateUrl: './salecompany-regist-comp.component.html',
  styleUrls: ['./salecompany-regist-comp.component.scss'],
})
export class SaleCompanyRegistCompComponent implements OnInit {
  constructor(
    private router: Router,
    public data: DataProvider,
    private route: ActivatedRoute,
    public translate: TranslateService,
  ) {}

  ngOnInit() {
    this.data.menuPageTitle = 'wf-salecompany-apply-list';
    this.widthChanger('main-header', 360);
  }
  back() {
    this.router.navigate(['/wf-salecompany-apply-list']);
  }
  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i] as HTMLElement;
          
          header.style.minWidth = width.toString() + 'px';
      }
  }
}
